module.exports = __webpack_public_path__ + "img/1280x720-Day.c18eb90d.jpg";